import React from 'react';
import PropTypes from "prop-types";


const RegistrationSteps = ({formNumber, scrollClass, setSpecificStep}) => {

    //Renders
    const renderStep1 = () => (
        <li className={
            formNumber === 1
                ? "active"
                : "done"
        }
        >
          
            <a href="#tab1" data-toggle="tab" className="step" onClick={e => setSpecificStep(1)}>
                <div className="progressBarWizard"></div>
                <span className="stepInfo">
                    <span>1</span>
                </span>
                <small>Basics</small>
            </a>
           
        </li>
    );
    const renderStep2 = () => (
        <li
            className={
                formNumber === 2
                    ? "active"
                    : (formNumber > 2 ? "done" : "")
            }
        >
            <a href="#tab1" data-toggle="tab" className="step" onClick={e => setSpecificStep(2)}>
                <div className="progressBarWizard"></div>
                <span className="stepInfo">
                    <span>2</span>
                </span>
                <small>Education</small>
            </a>
        </li>
    );
    const renderStep3 = () => (
        <li
            className={
                formNumber === 3
                    ? "active"
                    : (formNumber > 3 ? "done" : '')
            }
        >
            <a href="#tab1" data-toggle="tab" className="step" onClick={e => setSpecificStep(3)}>
                <div className="progressBarWizard"></div>
                <span className="stepInfo">
                    <span>3</span>
                </span>
                <small>Environment</small>
            </a>
        </li>
    );
    const renderStep4 = () => (
        <li
            className={
                formNumber === 4
                    ? "active"
                    : (formNumber > 4 ? "done" : '')
            }
        >
           <a href="#tab1" data-toggle="tab" className="step" onClick={e => setSpecificStep(4)}>
                <div className="progressBarWizard"></div>
                <span className="stepInfo">
                    <span>4</span>
                </span>
                <small>Official test</small>
            </a>
        </li>
    );
    const renderStep5 = () => (
        <li
            className={
                formNumber === 5
                    ? "active"
                    : (formNumber > 5 ? "done" : "")
            }
        >
            <a href="#tab1" data-toggle="tab" className="step" onClick={e => setSpecificStep(5)}>
                <div className="progressBarWizard"></div>
                <span className="stepInfo">
                    <span>5</span>
                </span>
                <small>Review</small>
            </a>
        </li>
    );

/*
    const renderStep6 = () => (
        <li
            className={
                formNumber === 6
                    ? "active"
                    : (formNumber > 6 ? "done" : "")
            }
        >
            <a href="#tab1" data-toggle="tab" className="step">
                <div className="progressBarWizard"></div>
                <span className="stepInfo">
                    <span>6</span>
                </span>
                <small>Getting Started</small>
            </a>
        </li>
    );

    const renderStep7 = () => (
        <li
            className={
                formNumber === 7
                    ? "active"
                    : ""
            }
        >
            <a href="#tab1" data-toggle="tab" className="step">
                <div className="progressBarWizard"></div>
                <span className="stepInfo">
                    <span>7</span>
                </span>
                <small>Diagnostics</small>
            </a>
        </li>
    );
*/
    return (
        <ul className={`nav nav-pills nav-justified steps ${scrollClass}`}>
            {renderStep1()}
            {renderStep2()}
            {renderStep3()}
            {renderStep4()}
            {renderStep5()}
            
        </ul>
    )
};

RegistrationSteps.propTypes = {
    formNumber: PropTypes.number.isRequired,
};


export default RegistrationSteps;



















// WEBPACK FOOTER //
// ./src/components/onBoarding/RegistrationSteps.js